module.exports = __webpack_public_path__ + "img/invalid.1792cdd2.png";